<sc-flex vertical fitHeight stretchContent>
  @if (showBarrierSelection) {
    <div [formGroup]="formGroup" class="no-field-space">
      <sc-flex>
        <sc-checkbox-field formControlName="bookEntrance" labelDictionaryKey="tmc-yard.ui.control.cep.action.book-entrance"></sc-checkbox-field>
        <sc-content-spacer></sc-content-spacer>
        <mat-form-field appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.cep.label.entrance"></sc-dictionary-label>
          </mat-label>
          <mat-select name="entrance" formControlName="entrance">
            @for (o of entrances; track o) {
              <mat-option [value]="o">
                {{o.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </sc-flex>
    </div>
    <sc-content-spacer vertical></sc-content-spacer>
  }
  <sc-flex-fitting-content vertical>
    <sc-loading-spinner [isLoading]="isLoading">
      <div class="grid">
        @if (cameraUrl) {
          <app-cep-camera-tile class="camera-tile" [url]="cameraUrl"></app-cep-camera-tile>
        }
        @for (profile of profiles; track profile) {
          <app-cep-profile-tile [profile]="profile"
          (click)="handleProfileClick(profile);"></app-cep-profile-tile>
        }
      </div>
    </sc-loading-spinner>
  </sc-flex-fitting-content>
</sc-flex>
